exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".expired[data-v-24d6061b]{margin-bottom:18px;font-size:16px;line-height:1.3;font-weight:700;color:rgba(0,0,0,.8);padding:8px 12px;border:1px solid #ff8921;border-radius:.2em}.expired_accent[data-v-24d6061b]{color:#bd2020}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-24d6061b","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/profile/views/certificate/components/expiredcert/ExpiredCert.vue
// module id = 512feda8146b81582eaa
// module chunks = 9